import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const stripeStateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/stripe/state',
  validateSearch: z.object({
    pharmacy_id: z.number(),
    token: z.preprocess((v) => (v === undefined ? undefined : `${v}`), z.string()),
  }),
}).lazy(() => import('pages/shared/StripeStatePage/StripeStatePage').then((d) => d.Route));
